/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Grid_Item_LabelInputs */

const cs_builder_grid_item_label = /** @type {(inputs: Builder_Grid_Item_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Štítek`)
};

const en_builder_grid_item_label = /** @type {(inputs: Builder_Grid_Item_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Label`)
};

/**
* | output |
* | --- |
* | "Label" |
*
* @param {Builder_Grid_Item_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_grid_item_label = /** @type {((inputs?: Builder_Grid_Item_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Grid_Item_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_grid_item_label(inputs)
	return cs_builder_grid_item_label(inputs)
});